export class Factory {
  static GET_EMPTY_SITE = () => ({
    label: '',
    value: '',
    nodeRef: '',
  });

  static GET_INITIAL_STATE = (selected: { [nodeRef: string]: string }) => ({
    sites: {},
    currentSite: Factory.GET_EMPTY_SITE(),
    selected: selected,
    breadcrumbs: [],
    searchQuery: '',
    currentSelected: [],
    content: [],
    treeItems: {},
    searchMode: false,
    loadingItem: '',
    loadingContent: false,
    sort: true,
    sortByValue: 'cm:name',
    page: 1,
    total: 0,
    pageSize: 10,
    filter: '',
    favouriteDocuments: {},
    favouriteFolders: {},
  });
}
